import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Box, InputAdornment } from '@material-ui/core';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';

import { TextField } from 'common/components/TextField';

import { TextInputWrapper } from '../TextInputWrapper';
import { CurrentLocationButton } from '../CurrentLocationButton';
import { breakpoints } from '../../constants';

const SearchAdornment = styled(InputAdornment)`
    cursor: pointer;
`;

interface IProps {
    className?: string;
    inputValue: string;
    findingCurrentLocation: boolean;
    useCurrentLocation: boolean;
    onInputChange(e: React.ChangeEvent<HTMLInputElement>): void;
    onFormSubmit(e: React.FormEvent<HTMLFormElement>): void;
    onCurrentLocationButtonClick(): void;
    onSearchButtonClick(): void;
}

const BaseLocationBarView: React.FC<IProps> = ({
    className,
    inputValue,
    findingCurrentLocation,
    useCurrentLocation,
    onInputChange,
    onFormSubmit,
    onCurrentLocationButtonClick,
    onSearchButtonClick,
}) => {
    const { t } = useTranslation();

    return (
        <form className={className} onSubmit={onFormSubmit}>
            <TextInputWrapper>
                <Box mr={2} width="100%">
                    <TextField
                        InputProps={{
                            endAdornment: (
                                <SearchAdornment
                                    position="start"
                                    onClick={onSearchButtonClick}
                                >
                                    <SearchOutlinedIcon
                                        className="searchIcon"
                                        fontSize="default"
                                    />
                                </SearchAdornment>
                            ),
                        }}
                        label={t('appointment.locationBarPlaceholder')}
                        value={inputValue}
                        variant="filled"
                        onChange={onInputChange}
                    />
                </Box>
            </TextInputWrapper>
            <CurrentLocationButton
                active={useCurrentLocation}
                loading={findingCurrentLocation}
                onClick={onCurrentLocationButtonClick}
            />
        </form>
    );
};

export const LocationBarView = styled(BaseLocationBarView)`
    display: flex;

    ${TextInputWrapper} {
        display: flex;
        margin: 0 auto;
        width: 100%;
        height: 100%;

        @media (${breakpoints.mediumMin}) {
            margin: 0;
        }
    }

    ${TextField} {
        width: 100%;

        .searchIcon {
            width: 25px;
            height: 25px;

            path {
                fill: ${({ theme }) => theme.palette.grey[200]};
            }
        }
    }
`;
